define('shared/get-url-parameter',[], function () {

	var GetURLParameter = function GetURLParameter()
	{
		this.url = new URLSearchParams(window.location.search);
	}

	GetURLParameter.prototype.get = function(param) {
		return this.url.get(param);
	}

	return new GetURLParameter();
});
